import { ListItem } from 'design-system'
import { RouteName } from 'projects/aiomed/src/core/enums/route-name.enum'

export const CNA_SIDEMENU_ITEMS: ListItem[] = [
  // { icon: 'home', title: 'Home', link: '/' + RouteName.Reports }
]

// Personal Assistant nav item (clinician-facing). Gated behind the feature flag in MenuComponent.
export const MY_PLAN_ITEM: ListItem = {
  icon: 'aio:house',
  title: 'Home',
  link: '/' + RouteName.MyPlan
}

export const ADMIN_DESKTOP_ITEMS = (notificationCount: number): ListItem[] => {
  return [
    {
      icon: 'aio:patients',
      title: 'Patients',
      link: '/' + RouteName.Patients
    },
    {
      icon: 'aio:insights-not-filled',
      title: 'Insights',
      link: '/' + RouteName.Insights
    },
    {
      icon: 'aio:bell',
      link: '/' + RouteName.Notifications,
      isNFType: true,
      badgeCount: notificationCount
    }
  ]
}

export const AUTOMATIC_DEPARTMENT_ITEMS = (
  notificationCount: number
): ListItem[] => {
  return [
    {
      icon: 'home',
      title: 'Home',
      link: '/' + RouteName.Home,
      exact: true
    },
    {
      icon: 'aio:patients',
      title: 'Residents',
      link: '/' + RouteName.Patients
    },
    {
      icon: 'aio:devices',
      title: 'Devices',
      link: '/' + RouteName.Devices
    },
    {
      icon: 'aio:insights-not-filled',
      title: 'Insights',
      link: '/' + RouteName.Insights
    },
    {
      icon: 'aio:alert',
      title: 'Alerts',
      link: '/' + RouteName.Alerts
    },
    {
      icon: 'aio:vitals',
      title: 'Vitals',
      link: '/' + RouteName.Reports
    },
    {
      icon: 'aio:bell',
      link: '/' + RouteName.Notifications,
      isNFType: true,
      badgeCount: notificationCount
    }
  ]
}

export const SEMI_AUTOMATIC_DEPARTMENT_ITEMS = (
  notificationCount: number
): ListItem[] => {
  return [
    {
      icon: 'home',
      title: 'Home',
      link: '/' + RouteName.Home,
      exact: true
    },
    {
      icon: 'aio:patients',
      title: 'Residents',
      link: '/' + RouteName.Patients
    },
    {
      icon: 'aio:insights-not-filled',
      title: 'Insights',
      link: '/' + RouteName.Insights
    },
    {
      icon: 'aio:vitals',
      title: 'Vitals',
      link: '/' + RouteName.Reports
    },
    {
      icon: 'aio:bell',
      link: '/' + RouteName.Notifications,
      isNFType: true,
      badgeCount: notificationCount
    }
  ]
}
